import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { formatViewabilityLabel } from '../../../../lineItemHelpers'

import { dv360TargetingSelector } from '../../../../../../modules/selectors/dv360Constants'

import { targetingTypes } from '../../../LineItemDv360Create/fields'

const ViewabilitySectionPreview = () => {
  const targeting = useSelector(dv360TargetingSelector)

  const formattedViewabilityLabel = useMemo(() => {
    const viewability = targeting.find(item => item.type === targetingTypes.TARGETING_TYPE_VIEWABILITY)
    return viewability ? formatViewabilityLabel(viewability.viewability) : ''
  }, [targeting])

  if (!formattedViewabilityLabel) {
    return null
  }

  return <p>{formattedViewabilityLabel}</p>
}

export default ViewabilitySectionPreview
